module.exports = __webpack_public_path__ + "img/human_63.5025a17b.png";